<template lang="pug">
.search-query
  .search-query__form
    Dropdown(
      v-for="dropdown in activeDropdowns"
      :dropdown="dropdown"
      :extend="extend"
      :key="dropdown.id"
      :executeSearch="executeSearch",
      :clearPreviousItemResults="clearPreviousItemResults")
</template>

<script>
import Dropdown from './Dropdown.vue'
export default {
  name: "BlueQuery",
  props: ["executeSearch", "extend", "extended", "clearPreviousItemResults"],
  components: {Dropdown},
  data() {
    return {
    };
  },
  computed: {
    activeDropdowns() {
      return this.extended.dropdowns.filter(d => d.active);
    },
  }
};
</script>

<style lang="scss">
.search-query {
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  flex: 1 1 100%;
  gap: 0.5rem;
  @include mq(sm) {
    gap: 0;
  }
  &__form {
    display: flex;
    flex-direction: column;
    position: relative;
    flex: 1 1 100%;
    padding: 0;
    margin: 0;
    gap: 0.5rem;
    justify-content: space-between;
    @include mq(lg) {
      gap: 0;
      flex-direction: row;
    }
  }
  &__wrapper {
    display: flex;
    width: 100%;
    border: 1px solid var(--border-color);
    &:focus-within {
      box-shadow: inset 0 0 0 0.125rem var(--focus-color);
    }
    @include mq(sm) {
      flex: 1 1 100%;
    }
  }
  &__input {
    @include clean(input);
    width: 100%;
    margin: 0;
    padding: 1rem;
    @include mq(sm) {
      flex: 1 1 100%;
    }
    &:focus {
      box-shadow: none !important;
    }
    &::placeholder {
      color: var(--color);
      font-weight: 300;
    }
  }
  &__reset {
    align-self: center;
    flex: 0 0 auto;
    appearance: none;
    border: none;
    background: none;
    border-radius: 0;
    cursor: pointer;
    padding: 0.5rem;
    margin: 0 0.5rem;
    font-weight: 700;
    color: var(--reset-color);
    transition: var(--reset-transition);
    &:hover {
      color: var(--reset-hover-color);
    }
  }
  &__submit {
    @include clean(button);
    flex: 0 0 auto;
    padding: 1rem;margin-bottom: 2.5rem;
		border-radius: 2rem;
    border-width: .1rem;
    border-style: solid;
    border-color: #fff;
    background: var(--button-background);
    color: var(--button-color);
    transition: var(--button-transition);
    @include mqdn(sm) {
      order: 4;
    }
    &:hover {
      background: var(--button-hover-background);
      color: var(--button-hover-color);
    }
  }
  &__sort {
    position: relative;
    flex: 0 0 auto;
    margin: 0;
    border: 1px solid var(--border-color);
    display: flex;
    align-items: center;
    width: 100%;
    &::after {
      content: "";
      position: absolute;
      top: 50%;
      right: 1.25rem;
      height: 0.5rem;
      width: 0.5rem;
      border-left: 2px solid;
      border-bottom: 2px solid;
      transform: translate(50%, -75%) rotate(-45deg);
    }
    @include mq(lg) {
      width: 32.5%;
    }
    select {
      @include clean(input);
      padding: 1rem;
      width: 100%;
    }
  }
  &__results {
    line-height: 1;
    padding: 0.25rem 0.5rem;
    font-size: 0.75rem;
    align-self: flex-start;
    background: var(--label-background);
    color: var(--label-color);
  }
}
</style>